import { Product } from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import type { FlightContext } from "../..";

export const guards = {
  isBaggageEligible: (ctx: FlightContext) => {
    const isExtraBagsEnabled = ctx[ParentState.featureFlags].enableExtraBags;
    const hasCheckedBagPrices =
      ctx[ParentState.bagsSelection].checkedBagsPrices?.length > 0;
    const hasExtraBaggageInBreakdown =
      ctx[ParentState.cartQuote].quoteBreakdown?.products.find(
        (p) => p.product.type === Product.Flight
      )?.product?.value?.pricingSummary?.extraBaggage !== undefined;

    return (
      isExtraBagsEnabled && hasCheckedBagPrices && hasExtraBaggageInBreakdown
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
